import React from "react";
import { ReferenceField, TextField } from "react-admin";

export const CoolerTypeField = ({ source = "cooler_type_id", ...props }) => (
	<ReferenceField {...props} source={source} reference="cooler-types" link={false}>
		<TextField source="name" />
	</ReferenceField>
);
